const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('5K1NL4D040', 'NTY1N2RiZjc4MWZiMzQ1MTgwZmE3MGEzODhjMTAwMDJjMmRlZDcxNTdlZWIyMjRjOThmMzc2NDIwZmYxZGJmNXJlc3RyaWN0SW5kaWNlcz1jZG5fcHVibGljX3YxKiZudW1lcmljRmlsdGVycz0lNUIlNUIlMjJ2aXNpYmlsaXR5JTNFMjAwJTIyJTVEJTVE');
const indexName = 'cdn_public_v1_en-GB';
const widgetsForAttributes = {
  'docno': 'menu',
  'meta.equipmenttype': 'menu',
  'meta.chaptercategory': 'refinementList',
  'format': 'menu',
  'lang': 'menu',
};

let url = window.location.href.split('?')[0];
let params = new URLSearchParams(window.location.search);
if (!params.has('docno')) params.set('docno', 'copsule');
if (!params.has('format')) params.set('format', 'web');
if (!params.has('lang')) params.set('lang', 'en-GB');
window.history.replaceState(history.state, "", url + "?" + params.toString());

const search = instantsearch({
  searchClient,
  indexName: indexName,
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const state = uiState[indexName];
        const route = {
          query: state.query,
          page: state.page
        };
        ['refinementList', 'hierarchicalMenu', 'menuSelect', 'menu'].forEach((widget) => {
          if (state[widget]) {
            for (var attribute in state[widget]) {
              route[attribute] = state[widget][attribute];
            }
          }
        });
        return route;
      },
      routeToState(routeState) {
        const state = {
          [indexName]: {
            refinementList: {},
            hierarchicalMenu: {},
            menuSelect: {},
            menu: {},
          },
        };
        for (const key in routeState) {
          if (key in widgetsForAttributes) {
            const widget = widgetsForAttributes[key];
            state[indexName][widget][key] = routeState[key];
            continue;
          }
          ['query', 'page'].forEach((attribute) => {
            if (key === attribute) {
              state[indexName][attribute] = routeState[key];
            }
          });
        }
        return state;
      },
    },
  },
});

function get(fallback, obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) return fallback;
  if (rest.length === 0 && obj.hasOwnProperty(level)) {
      if ((obj[level] === null) && (fallback !== null)) return fallback;
      return obj[level];
  }
  return get(fallback, obj[level], ...rest);
}

function set(obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) throw Error("Invalid object supplied!");
  if ((level === undefined) || (level === null)) throw Error("At least one level must be supplied");
  if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
  if (rest.length === 1) {
    obj[level] = rest[0];
  } else {
    set(obj[level], ...rest);
  }
}

// Helper: convert a label to sentence case (First letter upper, rest lower)
function toSentenceCase(text) {
  if (text == null) return text;
  const s = String(text).trim();
  if (!s) return s;
  const lower = s.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

function transformItems(attributes, items) {
  if (attributes) {
    if (!Array.isArray(attributes)) attributes = [attributes];
    // a specific attribute (facet)
    return items.map((item) => {
      for (const attribute of attributes) {
        if ((attribute in transformations) && (item.label in transformations[attribute])) {
          return {
            ...item,
            label: transformations[attribute][item.label],
            highlighted: transformations[attribute][item.label],
          };
        }
      }
      // Apply sentence case for specific facets if no explicit transformation matched
      if (attributes.includes('meta.equipmenttype') || attributes.includes('meta.chaptercategory')) {
        return {
          ...item,
          label: toSentenceCase(item.label)
        };
      }
      return item;
    });
  } else {
    // search results
    return items.map((item) => {
      let result = Object.assign({}, item);
      for (let attribute in item) {
        if ((attribute in transformations) && (item[attribute] in transformations[attribute])) {
          result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
          };
        } else {
          Object.keys(transformations).forEach((attribute) => {
            let fields = attribute.split('.');
            if (fields.length > 0) {
              let value = get(null, item, ...fields);
              if ((value != null) && (value in transformations[attribute])) {
                set(result, ...fields, transformations[attribute][value]);
              }
            }
          })
        }
      }
      // Ensure subtitle is sentence-cased
      if (result.titletopic != null) {
        result.titletopic = toSentenceCase(result.titletopic);
      }
      return result;
    });
  }
}

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
    placeholder: 'Search for content',
  }),
  instantsearch.widgets.menu({
    container: '#docno-menu',
    transformItems: transformItems.bind(this, 'docno'),
    attribute: 'docno',
    cssClasses: {
      link: 'link-primary',
    },
  }),
  instantsearch.widgets.menu({
    container: '#equipmenttype-menu',
    transformItems: transformItems.bind(this, 'meta.equipmenttype'),
    attribute: 'meta.equipmenttype',
    limit: 5,
    showMore: true,
    showMoreLimit: 1000,
    cssClasses: {
      link: 'link-primary',
    },
  }),
  instantsearch.widgets.refinementList({
    container: '#chapter-list',
    transformItems: transformItems.bind(this, 'meta.chaptercategory'),
    attribute: 'meta.chaptercategory',
    limit: 5,
    showMore: true,
  }),
  instantsearch.widgets.menuSelect({
    container: '#format-select',
    transformItems: transformItems.bind(this, 'format'),
    attribute: 'format',
    templates: {
      defaultOption: 'Any',
    }
  }),
  instantsearch.widgets.menuSelect({
    container: '#lang-select',
    transformItems: transformItems.bind(this, 'lang'),
    attribute: 'lang',
    templates: {
      defaultOption: 'Any', 
    }
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
  instantsearch.widgets.configure({
    attributesToSnippet: ['content:30'], // increase word count (e.g., 80)
    snippetEllipsisText: '…',           // optional: custom ellipsis
    maxValuesPerFacet: 1000
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    transformItems: transformItems.bind(this, null),
    templates: {
      item: `
<article class="card">
  <div class="card-body">
    <a class="link-primary text-decoration-none" href="https://copsule.leeaint.com{{ url }}">
    <h4 class="card-title">{{ meta.equipmenttype}}</h4>    
    <h6 class="card-subtitle mb-2">{{ titletopic }}</h6>
    </a>
    <p class="card-text">{{#helpers.snippet}}{ "attribute": "content" }{{/helpers.snippet}}</p>
    <div class="col">
        <a class="link-primary text-decoration-none" href="https://copsule.leeaint.com{{ url }}">
        <h4 class="card-title">Read more</h4> 
        </a>
      </div>
  </div>
  <div class="card-footer">
    <div class="row justify-content-end">
      <div class="col">
        <a class="link-primary text-decoration-none" href="https://copsule.leeaint.com{{ url }}">
        <h4 class="card-title"></h4> 
        </a>
      </div>
      <div class="col-auto">
        <language-picker
          size="sm"
          lazy="true"
          class="navbar-language-picker"
          variant="lp"
          menuVariant="lp"
          docno="{{docno}}"
          default="{{lang}}"
          version="{{version}}"
          urlprefix="https://copsule.leeaint.com"
          algoliaAppId="5K1NL4D040"
          algoliaApiKey="NTY1N2RiZjc4MWZiMzQ1MTgwZmE3MGEzODhjMTAwMDJjMmRlZDcxNTdlZWIyMjRjOThmMzc2NDIwZmYxZGJmNXJlc3RyaWN0SW5kaWNlcz1jZG5fcHVibGljX3YxKiZudW1lcmljRmlsdGVycz0lNUIlNUIlMjJ2aXNpYmlsaXR5JTNFMjAwJTIyJTVEJTVE"
          algoliaIndexName="cdn_public_v1"
        ></language-picker>
      </div>
    </div>
  </div>
</article>
`,
    },
  }),
]);

search.start();
